export default "__VITE_ASSET__Bbmd2gB0__"